import React, { useCallback } from "react";
import { Alert, Snackbar } from "@mui/material";
import BuyNumberSection from "./BuyNumberSection";
import AvailableNumbers from "./AvailableNumbers";
import PurchasedNumbers from "./PurchasedNumbers";
import UploadGreetingModal from "./UploadGreetingModal";
import BuyConfirmModal from "./BuyConfirmModal";
import ReleaseConfirmModal from "./ReleaseConfirmModal";
import useNumberManagement from "../hooks/useNumberManagement";
import "../../logs/Logs.css";
import { PageHeader } from "../../../shared/components/common";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleQuestion } from "@fortawesome/free-solid-svg-icons";

const NumberManagement = () => {
  const {
    selectedCountry,
    setSelectedCountry,
    searchCriteria,
    setSearchCriteria,
    searchDigits,
    setSearchDigits,
    matchTo,
    setMatchTo,
    availableNumbers,
    availablePageSize,
    purchasedNumbers,
    availableLoading,
    purchasedLoading,
    actionLoading,
    availableSpread,
    purchasedSpread,
    onToggleAvailableSpread,
    onTogglePurchasedSpread,
    handleSearch,
    handleReset,
    showBuyModal,
    showUploadModal,
    showReleaseModal,
    selectedNumber,
    handleBuyClick,
    handleBuyConfirm,
    handleUploadClick,
    handleUploadGreeting,
    handlePlayGreeting,
    handleReleaseClick,
    handleReleaseConfirm,
    handleCancel,
    snackbar,
    setSnackbar,
    canEditNumbers,
  } = useNumberManagement();


  const handleSettingsClick = useCallback(() => {
    // Placeholder for settings/sort functionality
  }, []);

  return (
    <div className="flex flex-col w-full h-full bg-transparent">

      <PageHeader
        title="Number Management"
        subtitle="Purchase and manage voicemail numbers and greetings."
        >
        <button
          onClick={handleSettingsClick}
          className="flex items-center gap-2 px-4 py-2.5 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-100"
        >
          <FontAwesomeIcon icon={faCircleQuestion} className="text-base" />
          <span>Can't find a number?</span>
        </button>
      </PageHeader>
      {/* Buy a Number Section */}
      <BuyNumberSection
        selectedCountry={selectedCountry}
        setSelectedCountry={setSelectedCountry}
        searchCriteria={searchCriteria}
        setSearchCriteria={setSearchCriteria}
        searchDigits={searchDigits}
        setSearchDigits={setSearchDigits}
        matchTo={matchTo}
        setMatchTo={setMatchTo}
        onSearch={handleSearch}
        onReset={handleReset}
      />

      {/* Available Numbers Table */}
      <AvailableNumbers
        numbers={availableNumbers}
        onBuy={handleBuyClick}
        spreadTable={availableSpread}
        onSpreadTableToggle={onToggleAvailableSpread}
        loading={availableLoading}
        pageSize={availablePageSize}
        canEdit={canEditNumbers}
      />

      {/* Purchased Numbers Table */}
      <PurchasedNumbers
        numbers={purchasedNumbers}
        onUploadGreeting={handleUploadClick}
        onPlayGreeting={handlePlayGreeting}
        onRelease={handleReleaseClick}
        spreadTable={purchasedSpread}
        onSpreadTableToggle={onTogglePurchasedSpread}
        loading={purchasedLoading}
        canEdit={canEditNumbers}
      />

      {/* Modals */}
      <BuyConfirmModal
        show={showBuyModal}
        number={selectedNumber}
        onCancel={handleCancel}
        onConfirm={handleBuyConfirm}
        processing={actionLoading}
      />

      <UploadGreetingModal
        show={showUploadModal}
        number={selectedNumber}
        onCancel={handleCancel}
        onUpload={handleUploadGreeting}
      />

      <ReleaseConfirmModal
        show={showReleaseModal}
        number={selectedNumber}
        onCancel={handleCancel}
        onConfirm={handleReleaseConfirm}
        processing={actionLoading}
      />

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          severity={snackbar.severity}
          onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default NumberManagement;
